__turbopack_context__.v({
  "button": "styles-module__oLUxnq__button",
  "container": "styles-module__oLUxnq__container",
});
